import Swiper from '../../../../node_modules/swiper/swiper-bundle.mjs';

export const initQwizStep = function () {
  const sliderQwizStep = document.querySelector('[data-slider-qwiz="slider"]');
  if (!sliderQwizStep) {
    return;
  }

  const swiperQwizStep = function () {
    new Swiper(sliderQwizStep, {
      spaceBetween: 10,
      slidesPerView: 1,
      navigation: {
        nextEl: '[data-slider-qwiz="arrow-next"]',
        prevEl: '[data-slider-qwiz="arrow-prev"]',
      },
      pagination: {
        el: '[data-slider-qwiz="step"]',
        type: "custom",
        renderCustom: function (swiper, current, total) {
          return `<span class="qwiz__pagination-step-text">Шаг ${current}</span> из ${total}`
        }
      },
    }
    );
  }
  swiperQwizStep();
};
